import React, { Component } from 'react';
import './Home.css';

// import Header from '../Header/Header'
import Body from '../Body/Body'
import GetInTouch from '../GetInTouch/GetInTouch'
import Footer from '../Footer/Footer'


class Home extends Component {
  render() {
    return (
      <div>
        {/* <Header /> */}
        <Body data={this.props.data}/>
        <GetInTouch />
        <Footer />
      </div>
    );
  }
}

export default Home;
